(() => {
  if (window.__croColorSwap) return;
  window.__croColorSwap = true;

  const widths = [240, 352, 832, 1200, 1600];
  const ready = new Map();

  const style = document.createElement('style');
  style.textContent = '.card-gallery img{transition:opacity .22s ease}';
  document.head.appendChild(style);

  const withWidth = (src, width) => {
    try {
      const absolute = src.startsWith('//') ? `https:${src}` : src;
      const url = new URL(absolute, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString().replace(/^https:/, '');
    } catch {
      return src;
    }
  };

  const preload = (src) => {
    if (!src || ready.has(src)) return ready.get(src);
    const img = new Image();
    img.decoding = 'async';
    img.src = withWidth(src, 832);
    ready.set(src, img);
    return img;
  };

  const setImage = (img, src, alt) => {
    if (!src) return;
    img.alt = alt;
    img.srcset = widths.map((width) => `${withWidth(src, width)} ${width}w`).join(', ');
    img.src = withWidth(src, 1200);
  };

  const productPath = (href) => {
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/$/, '');
    } catch {
      return '';
    }
  };

  const cardRoot = (node) => node.closest('product-card, .product-card');

  const swatchHref = (swatch) => swatch.getAttribute('href') || swatch.dataset.croHref || '';

  const disarmCardSwatches = (root = document) => {
    root.querySelectorAll('a.bc-siblings__swatch').forEach((anchor) => {
      const card = cardRoot(anchor);
      if (!card || anchor.closest('.product-details')) return;
      if (!anchor.dataset.croHref) anchor.dataset.croHref = anchor.getAttribute('href') || '';
      anchor.removeAttribute('href');
      anchor.setAttribute('role', 'button');
    });
  };

  const warm = () => {
    document.querySelectorAll('a.bc-siblings__swatch[data-cro-image]').forEach((swatch) => {
      preload(swatch.dataset.croImage);
    });
  };

  warm();

  const apply = (card, swatch) => {
    const title = swatch.dataset.croTitle || swatch.getAttribute('aria-label') || '';
    const price = swatch.dataset.croPrice || '';
    const handle = swatch.dataset.croHandle || '';
    const id = swatch.dataset.croId || '';
    const sources = (swatch.dataset.croImages || swatch.dataset.croImage || '').split('||').filter(Boolean);
    const path = productPath(swatchHref(swatch));

    if (id) {
      card.dataset.productId = id;
      const item = card.closest('li[data-product-id]');
      if (item) item.dataset.productId = id;
    }

    card.querySelectorAll('a.product-card__link, a.contents, a.bc-product-title__link').forEach((link) => {
      if (path) link.href = path;
      if (title && link.hasAttribute('aria-label')) link.setAttribute('aria-label', title);
    });

    const titleNode = card.querySelector('.bc-product-title__text [role="heading"]') || card.querySelector('.bc-product-title__text p');
    if (titleNode && title) titleNode.textContent = title;

    const priceNode = card.querySelector('product-price .price');
    const priceRoot = card.querySelector('product-price');
    const priceBox = card.querySelector('product-price [ref="priceContainer"], product-price .price-container');
    if (priceBox && swatch.dataset.croFestive === '1' && swatch.dataset.croCompare && price) {
      priceBox.classList.add('price-container--festive');
      priceBox.replaceChildren();
      const sale = document.createElement('span');
      sale.className = 'price-item__group price';
      sale.textContent = price;
      const compare = document.createElement('span');
      compare.className = 'price-item__group price-item--regular compare-at-price';
      compare.textContent = swatch.dataset.croCompare;
      priceBox.append(sale, compare);
      const off = Number(swatch.dataset.croOff || 0);
      if (off > 0) {
        const badge = document.createElement('span');
        badge.className = 'price-discount-percent';
        badge.textContent = off + '% OFF';
        priceBox.append(badge);
      }
      const labelText = swatch.dataset.croFestiveLabel || '';
      if (labelText) {
        const label = document.createElement('span');
        label.className = 'price-festive-label';
        label.textContent = labelText;
        priceBox.append(label);
      }
    } else if (priceBox && priceBox.classList.contains('price-container--festive') && price) {
      priceBox.classList.remove('price-container--festive');
      priceBox.replaceChildren();
      const sale = document.createElement('span');
      sale.className = 'price';
      sale.textContent = price;
      priceBox.append(sale);
    } else if (priceNode && price) {
      priceNode.textContent = price;
    }
    if (priceRoot && id) priceRoot.dataset.productId = id;

    const gallery = card.querySelector('.card-gallery');
    if (gallery && id) gallery.dataset.productId = id;

    card.querySelectorAll('[data-bc-wl]').forEach((button) => {
      if (handle) button.dataset.bcWl = handle;
      if (title && button.hasAttribute('aria-label')) {
        button.setAttribute('aria-label', `Save ${title} to wishlist`);
      }
    });

    card.querySelectorAll('a.bc-siblings__swatch').forEach((dot) => {
      const selected = dot === swatch;
      dot.classList.toggle('is-current', selected);
      if (selected) dot.setAttribute('aria-current', 'page');
      else dot.removeAttribute('aria-current');
    });

    if (!gallery || !sources.length) return;
    const images = [...gallery.querySelectorAll('img')];
    if (!images.length) return;

    images.forEach((img, index) => {
      img.style.opacity = '1';
      setImage(img, sources[index] || sources[0], title);
    });
    preload(sources[0]);
  };

  document.addEventListener(
    'click',
    (event) => {
      const plus = event.target.closest('.bc-siblings__plus');
      if (plus) {
        const root = plus.closest('.bc-siblings');
        if (root && !root.closest('product-card')) {
          event.preventDefault();
          event.stopPropagation();
          root.classList.toggle('is-expanded');
        }
        return;
      }

      const swatch = event.target.closest('.bc-siblings__swatch');
      if (!swatch) return;
      const card = cardRoot(swatch);
      if (!card || swatch.closest('.product-details')) return;

      event.preventDefault();
      event.stopPropagation();

      const path = productPath(swatchHref(swatch));
      if (!path || card.dataset.croSwapPath === path) return;
      card.dataset.croSwapPath = path;
      apply(card, swatch);
    },
    true
  );

  disarmCardSwatches();
  document.addEventListener('shopify:section:load', (event) => {
    disarmCardSwatches(event.target || document);
  });

  if (typeof MutationObserver !== 'undefined') {
    let disarmTimer = 0;
    const observer = new MutationObserver(() => {
      window.clearTimeout(disarmTimer);
      disarmTimer = window.setTimeout(() => disarmCardSwatches(), 80);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
